import React, { useState } from "react";
import { getCardImage } from "../../resultVisuals/cardAssets";
import FlipCard from "./FlipCard";

/**
 * Video card overlay for 20-20 Poker (poker20), reference markup:
 *   .casino-video-cards[.hide-cards] > .casino-cards-shuffle + .casino-video-cards-container >
 *     .playeracards (Player A: cards[0,1]) · .playerbcards (Player B: cards[2,3]) · .playerboardcards (Board: cards[4..8])
 *   each = .dealer-name.w-100.mb-1 + .d-flex > <span><img></span>...
 * Hidden (hide-cards) while cards[0] is a back ("1"); the shuffle handle toggles it.
 */
export default function Poker20CardsOverlay({ card }) {
  const [showCards, setShowCards] = useState(true);
  if (card == null || card === "") return null;
  const cards = String(card).split(",").map((c) => c.trim());
  if (!cards.length) return null;
  const hidden = !showCards || cards[0] === "1";

  if (cards[0] === "1" && !showCards) setShowCards(true); // new round re-opens a hand-closed strip
  const group = (cls, title, idx) => (
    <div className={cls}>
      <div className="dealer-name w-100 mb-1">{title}</div>{" "}
      <div className="d-flex">
        {idx.map((i, n) => (
          <React.Fragment key={i}>
            {n > 0 && " "}
            <span>
              <FlipCard src={getCardImage(cards[i])} alt="" />
            </span>
          </React.Fragment>
        ))}
      </div>
    </div>
  );

  return (
    <div className={`casino-video-cards${hidden ? " hide-cards" : ""}`}>
      <div className="casino-cards-shuffle" onClick={() => cards[0] !== "1" && setShowCards((v) => !v)}>
        <i className="fas fa-grip-lines-vertical" />
      </div>{" "}
      <div className="casino-video-cards-container">
        {group("playeracards", "Player A", [0, 1])} {group("playerbcards", "Player B", [2, 3])}{" "}
        {group("playerboardcards", "Board", [4, 5, 6, 7, 8])}
      </div>
    </div>
  );
}
